
import React, { useState, useEffect } from 'react';
import './App.css';
import vinyl from "./FenceImages/VINYL.png";
import sleek from "./FenceImages/SLEEKFENCE.png";
import wood from "./FenceImages/PRESSURETREATED.png";
import total from './total';




function App() {
  //formula for calculation of the final cost calculation
  const [gate, setGateNum] = useState(0);
  const gateNum = (event) => 
  {
    setGateNum (event.target.value);
  }
  
  const [perimeter, setPerimeterNum] = useState(null);
  const perimeterOfGate = (event) => 
  {
    setPerimeterNum(event.target.value);
  }
  const preventMinus = (e) => {
    if (e.code === 'Minus') {
        e.preventDefault();
    }
    if(e.code === 'e')
    {
      e.preventDefault();
    }
  }
  const [fenceType, setFenceType] = useState('vinyl');
  const fenceSelected = (event) =>
  {
    setFenceType(event.target.value);
    console.log(event.target.value);
  }

  const [isSteep, setSlopeType] = useState(false);
  const slopeSelected = (event) => 
  {
    setSlopeType(event.target.checked);
    // console.log(event.target.checked);
  }

  const [isDemo, setDemoType] = useState(false);
  const demoSelected = (event) =>
  {
    setDemoType(event.target.checked);
    // console.log(event.target.checked);
  }
  const[isSplit, setSplitType] = useState(false);
  const splitSelected = (event) =>
  {
    setSplitType(event.target.checked);
    // console.log(event.target.checked);
  }
  const[Unsettotal, setTotal] = useState(null);

  useEffect(() => {
    // console.log(isDemo);
    total(fenceType ,perimeter ,gate ,isSteep ,isSplit ,isDemo, setTotal);
    
    // console.log(isDemo);
  },[fenceType, perimeter, gate, isSteep, isSplit, isDemo, Unsettotal]);


  
  return (
    <><div className="App">
      <h2 className='subHeader'>BUILD YOUR FENCE</h2>
      <h1 className='header'>ENTER SPECIFICATIONS</h1>

      <h5>For an accurate measurement, we suggest using the copy of your home's surveyor certificate or running a tape measure along the edge of the existing fence. </h5>

      <label className='labelNonButton'>Perimeter of Your Fence (Include Gate Openings)</label><br></br>
      <p></p>
      <input type="number" onInput= {(event)=> event.target.value.length > 1 ? 
                                event.target.value = 
                                event.target.value.slice(0, 5)
                                : 
                                event.target.value
                        }
             value={perimeter} onKeyPress={preventMinus} onChange={perimeterOfGate} ></input>
      <label> Linear Feet</label>

      <p></p>
      <label className='labelNonButton'>Enter Number of Gates:</label>
      <p></p>
      <select value={gate} onChange={gateNum}>
        <option value="0">0</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
      </select>
      <br></br><br></br>
      <label>Select Fence Type: </label>
      <br></br><br></br>
      <table className="e-btn-group">

      <label>
        <input name="fenceType" type="radio" value="vinyl" onChange={fenceSelected} defaultChecked/>
        <img src={vinyl} alt="vinyl" />
      </label>

        <label>
          
          <input name="fenceType" type="radio" value="treated" onChange={fenceSelected} />
          <img src={wood} alt="treated" />
        </label>

        <label>
          <input name="fenceType" type="radio" value="sleek" onChange={fenceSelected} />
          <img src={sleek} alt="sleek"/>
        </label>
        </table>

              <br></br>

              <label className='labelNonButton'>Is The Fence On A Steep Slope:  </label><br></br>
              <div className='toggle-switch'>
                <input className="checkbox" id="Steep" name="steepSlope" type="checkbox" value={isSteep} onChange={slopeSelected} />
                <label className='label' htmlFor="Steep">
                  <span className='inner' />
                  <span className="switch" />
                </label>
              </div>
              <br></br>
              <br></br>
            <label className='labelNonButton'>Add Demolition and Disposal of Current Fence:</label><br></br>
            <div className='toggle-switch'>
                <input className="checkbox" id="demo" name="demo" type="checkbox" value={isDemo} onChange={demoSelected} />
                <label className='label' htmlFor="demo">
                  <span className='inner' />
                  <span className="switch" />
                </label>
              </div>
              <br></br>
              <br></br><label className='labelNonButton'>Split Cost With Neighbor: </label><br></br>
              <div className='toggle-switch'>
                <input className="checkbox" id="Split" name="split" type="checkbox"  value={isSplit} onChange={splitSelected} />
                <label className="label" htmlFor='Split'>
                  <span className='inner' />
                  <span className="switch" />
                </label>
              </div><br></br><br></br><br></br>
              
              

              <h1 className='header'>ESTIMATED COST</h1>
              <h3 className='error'>{perimeter < 30 ? 'Your Perimeter Must Be Greater Than 30ft' : null}</h3>
              <span className='subHeader'>Your Total: <b>{Unsettotal}</b></span>
              </div>

      </>
          
    
  );
}

export default App;
